import * as React from 'react'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { applyFilters } from 'modules/core/components/EmployeeMultiFilters/hooks/useEmployeeMultiFilters'
import getMultiFilters from 'modules/core/components/MultiFilters/hooks/utils/getMultiFilters'
import { useEffect } from 'modules/core/hooks/useEffect'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import storedEmployees from 'modules/employees/store/collections/employees'
import { isStatusConflict } from 'modules/shift_management/components/ShiftManagement/Content/_filters/customFilters'
import getFilterValue from 'modules/shift_management/components/ShiftManagement/Content/_filters/getFilterValue'
import type { EmployeeWithShifts, ShiftsRow } from 'modules/shift_management/lib/types'

const useApplyFilters = (shiftsRows: ShiftsRow[], contractVersions: ContractVersions) => {
  const { filters: multiFilters, logicOperator } = getMultiFilters(
    LOCAL_STORAGE_KEYS.shiftEmployees
  )

  const employees = shiftsRows.flatMap((row) => row.employees)
  const [filteredEmployees, setFilteredEmployees] = React.useState<EmployeeWithShifts[]>([])

  useEffect(() => {
    applyFilters(
      storedEmployees.models,
      multiFilters,
      logicOperator,
      getFilterValue,
      setFilteredEmployees,
      contractVersions
    )
  }, [shiftsRows.length]) // eslint-disable-line react-hooks/exhaustive-deps

  // FIXME: In the future, we need to fix this behaviour updating backend to accept
  // those filters, here our problem is that we have custom filters (like shiftStatus)
  // and two different sources to get employees:
  // - 1. Multifilters applies for storedEmployees in the frontend.
  // - 2. Shift status filter applies for employees from DB in the backend.
  const getFilteredEmployees = () => {
    if (isStatusConflict(multiFilters)) {
      const employeeIds = employees.map((e) => e.id)

      return filteredEmployees.filter((e) => employeeIds.includes(e.id))
    }

    return filteredEmployees
  }

  return {
    filters: multiFilters,
    getFilteredEmployees,
  }
}

export default useApplyFilters
